import React, { createContext, useContext, useState } from 'react'

interface ModalContactContextData {
  showModalContact: boolean
  setShowModalContact: React.Dispatch<React.SetStateAction<boolean>>
  setFields: React.Dispatch<React.SetStateAction<any>>
  fields: any
}

export const ModalContactContext = createContext<ModalContactContextData>(
  {} as ModalContactContextData
)

export const ModalContactProvider: React.FC = ({ children }) => {
  const [showModalContact, setShowModalContact] = useState(false)
  const [fields, setFields] = useState<any>({})

  return (
    <ModalContactContext.Provider
      value={{
        showModalContact,
        setShowModalContact,
        setFields,
        fields
      }}
    >
      {children}
    </ModalContactContext.Provider>
  )
}

export function useModalContactContext() {
  return useContext(ModalContactContext)
}
